import { render, staticRenderFns } from "./ProductSearchCode.vue?vue&type=template&id=6054dc40&"
import script from "./ProductSearchCode.vue?vue&type=script&lang=js&"
export * from "./ProductSearchCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports